export default {
    baseStyle: {
        promotionalBlock: {
            position: 'relative'
        },
        promotionalHeading: {
            fontSize: 'fontSize28',
            lineHeight: '33.3px',
            color: {base: 'black', sm: 'white'},
            position: {base: 'static', sm: 'absolute'},
            top: '50%',
            transform: {base: 'unset', sm: 'translateY(-50%)'},
            left: '0',
            right: '0',
            margin: '0 auto',
            textAlign: 'center'
        },
        promotionalSubHeading: {
            fontSize: 'md',
            lineHeight: '6',
            color: 'black',
            textAlign: 'center',
            mt: '16px'
        }
    }
}
